import { useEffect, useState } from 'react';
import { GetLeaderDashboardService } from '../../services/DashboardServices';
import DashboardMenu from './DashboardMenu';
import { PiCoinVerticalFill } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';

function LeaderBoard() {


  const navigator = useNavigate()
  const [data,setdata] = useState([])

  useEffect(()=>{
    getData()

    const interval = setInterval(() => {
      getData();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  },[])

  const getRankIcon = (index) => {
    if (index === 0) return "🥇";
    if (index === 1) return "🥈";
    if (index === 2) return "🥉";
    return "";
  };

  async function getData() {

    const response = await GetLeaderDashboardService()
    setdata(response?.data?.data)
  }

  console.log("Data",data)


  function convertionRatio(d){
    let result = ((d?.subscribed_user / d?.customerCount) * 100).toFixed(2)
    return Math.round(result) + '%'
  }

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

     

      <div className='md:flex items-start'>
          <DashboardMenu />
        <div className='md:w-[90%] pl-5 pt-4'>

          <h6 className='font-bold mb-2'>Leader Board (See Your Points)</h6>
          
          {/* Desktop / tablet table */}
          <div className="hidden md:block w-full md:w-fit overflow-x-auto border">
            <div className="flex bg-[#2a297e] w-fit text-white items-center">
              <h6 className="min-w-[50px] w-[50px] text-[12px] p-2 font-bold border-r">Sl No</h6>
              <h6 className="min-w-[100px] w-[100px] text-[12px] p-2 font-bold border-r">Image</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">Name</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">Subscribed User</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">AppInstalled User</h6>
            </div>

  {data?.map((d, i) => (
    <div
      key={i}
      onClick={() => navigator('/dashboard/leader_board/detail', { state: d })}
      className={`flex w-fit font-bold border-t ${
                  i === 0 ? "bg-yellow-100" :
                    i === 1 ? "bg-gray-100" :
                      i === 2 ? "bg-orange-100" : ""
                }`}
    >
      <h6 className="min-w-[50px] w-[50px] text-[12px] p-2 font-bold border-r flex items-center gap-1"><span className='text-[25px]'>{getRankIcon(i)}</span> {i + 1}</h6>
      <h6 className="min-w-[100px] w-[100px] text-[12px] p-2 font-bold border-r">
        {!['',null,undefined,'null','undefined'].includes(d?.user?.profile_photo) && <img
          className="w-full h-[50px] object-contain"
          src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.user?.profile_photo}`}
        />}
      </h6>
      <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">
        {d?.user?.name}
      </h6>
      <h6 className="min-w-[150px] w-[150px] text-[12px] flex p-2 font-bold border-r">
        {d?.subscribed_user}
      </h6>
       <h6 className="min-w-[150px] w-[150px] text-[12px] flex p-2 font-bold border-r">
        {d?.appInstalledCount}
      </h6>
    </div>
  ))}
</div>

          {/* Mobile card list */}
          <div className='md:hidden space-y-2'>
            {data?.map((d, i) => (
              <div
                key={i}
                onClick={() => navigator('/dashboard/leader_board/detail', { state: d })}
                className={`flex items-center border rounded-md p-2.5 ${
                  i === 0 ? "bg-yellow-100" :
                    i === 1 ? "bg-gray-100" :
                      i === 2 ? "bg-orange-100" : "bg-white"
                }`}
              >
                {!['',null,undefined,'null','undefined'].includes(d?.user?.profile_photo) ? <img
                  className="w-10 h-10 object-contain rounded mr-2 flex-shrink-0"
                  src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.user?.profile_photo}`}
                /> : <span className='text-[22px] w-10 flex-shrink-0 text-center'>{getRankIcon(i) || i + 1}</span>}
                <div className='flex-1'>
                  <h6 className='text-[13px] font-[700]'>{d?.user?.name}</h6>
                  <h6 className='text-[11px] text-slate-600'>Subscribed: {d?.subscribed_user} &middot; App Installed: {d?.appInstalledCount}</h6>
                </div>
              </div>
            ))}
          </div>




        </div>
      </div>
    </div>
  )
}

export default LeaderBoard